// Function to report web performance metrics by passing a callback function (onPerfEntry)
const reportWebVitals = onPerfEntry => {
  // Check if the callback function is provided and is a valid function
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Dynamically import the 'web-vitals' library to avoid increasing bundle size upfront
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Measure Cumulative Layout Shift (CLS) and pass the result to onPerfEntry callback
      getCLS(onPerfEntry);
      // Measure First Input Delay (FID) and pass the result to onPerfEntry callback
      getFID(onPerfEntry);
      // Measure First Contentful Paint (FCP) and pass the result to onPerfEntry callback
      getFCP(onPerfEntry);
      // Measure Largest Contentful Paint (LCP) and pass the result to onPerfEntry callback
      getLCP(onPerfEntry);
      // Measure Time to First Byte (TTFB) and pass the result to onPerfEntry callback
      getTTFB(onPerfEntry);
    });
  }
};

// Export the reportWebVitals function as the default export of the module
export default reportWebVitals;
